<ng-container *ngIf="ready">
  <yc-banner *ngIf="banners"
    [banners]="banners">
  </yc-banner>

  <div *ngIf="langKeys"
    class="d-flex ms-3">
    <yc-language-selector
      class="lang-selector-login"
      [langKeys]="langKeys"
      (onLangChange)="onLangChange($event)">
    </yc-language-selector>
  </div>

  <!-- Mobile -->
  <div *ngIf="!isApply" 
    class="fs-modal mobile-block">
    <div class="fs-modal-content mobile-block">
      <div class="fs-modal-panel">
        <div class="fs-icon mobile-block fa  fa-laptop"></div>
        <div class="fs-header mobile-block">
          <yc-i18n 
            key="NAV:SCREEN_TOO_SMALL"
            defaultValue="This screen size is not supported">
          </yc-i18n>
        </div>
        <div class="fs-message mobile-block">
          <yc-i18n 
            key="common:textScreenSizeNotSupportedDescription"
            defaultValue="This application is designed for tablet and desktop use. Please increase the size of your browser or login from a supported device.">
          </yc-i18n>
        </div>
      </div>
    </div>
  </div>


  <div class="login-wrapper"
    [class.non-mobile]="!isApply">
    <div class="container mt-5">
      <!-- Tabs -->
      <div class="d-flex outer-tabs">
        <yc-horizontal-nav-tabs *ngIf="tabs.length > 1"
          [tabs]="tabs">
        </yc-horizontal-nav-tabs>
      </div>
      <div class="login-tab-content">
        <!-- Left Side -->
        <div class="col-md-3 yc-panel primary">
          <gc-login-extras></gc-login-extras>
        </div>
        <!-- Right Side -->
        <div class="col-md-9 login-content">
          <router-outlet></router-outlet>
        </div>
      </div>
      
      <!-- Non Mobile Footer -->
      <div class="d-none d-md-flex login-footer">
        <ng-template *ngTemplateOutlet="ycImage"></ng-template>
      
        <div *ngIf="!isBBGMApplicant"
          class="d-flex">
          <ng-template *ngTemplateOutlet="needAssistanceText"></ng-template>
          <ng-template *ngTemplateOutlet="helpActions"></ng-template>
        </div>
      </div>

      <!-- Mobile Footer -->
      <div class="d-md-none login-footer-mobile">
        <ng-template *ngTemplateOutlet="ycImage"></ng-template>
        <ng-container *ngIf="!isBBGMApplicant">
          <div class="mt-2 mb-2">
            <ng-template *ngTemplateOutlet="needAssistanceText"></ng-template>
          </div>
          <ng-template *ngTemplateOutlet="helpActions"></ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>


<ng-template #helpActions>
  <ul class="list-with-no-styles">
    <!-- Help Center -->
    <li>
      <a
        class="btn border-on-hover btn-link"
        target="_blank"
        [href]="helpLink"
      >  
      <yc-fa icon="info-circle"
        class="footerItems"
        [light]="false" 
      >
    </yc-fa>
      <yc-i18n
        key="common:textHelpCenter"
        defaultValue="Help Center">
      </yc-i18n>
    </a>
    </li>

    <!-- Contact Support -->
    <li *ngIf="!isUat">
      <yc-button
        [link]="true"
        [fontAwesomeIcon]="'envelope'"
        [langKey]="'common:btnContactSupport'"
        [defaultText]="'Contact support'"
        [tooltipText]="'common:textContactTooltipUpdated2' | ycI18n: 'Contact our support team for assistance with your application or profile'"
        class="me-2"
        (onClick)="contactSupport()">
      </yc-button>
    </li>

    <!-- Live Chat -->
    <li *ngIf="!isUat && isApply">
      <yc-button
        [link]="true"
        [fontAwesomeIcon]="'comments'"
        [langKey]="'common:liveChat'"
        [defaultText]="'Live chat'"
        (onClick)="openLiveChat()"
        [tooltipText]="'common:textChatTooltip' | ycI18n: 'Chat with a team member if you have a quick question or request'">
      </yc-button>
    </li>
  </ul>
</ng-template>

<ng-template #ycImage>
  <a href="https://solutions.yourcause.com"
    target="_blank"
    title="YourCause">
    <img src="./assets/img/imgIconPoweredBy.svg"
      [alt]="'GLOBAL:textPoweredBy' | ycI18n: 'Powered by YourCause'">
  </a>
</ng-template>

<ng-template #needAssistanceText>
  <div class="need-assistance mt-2">
    <yc-i18n 
      key="common:textNeedAssistance" 
      defaultValue="Need assistance?">
    </yc-i18n>
  </div>
</ng-template>